// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DrugForm__wrapper__3TkGp","submitResult":"DrugForm__submitResult__UwDFm","actionWrapper":"DrugForm__actionWrapper__3TYXo","wrapper2faOptions":"DrugForm__wrapper2faOptions__32H2T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DrugForm/DrugForm.css
// module id = 548
// module chunks = 0